import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        {/* Left Section */}
        <div className="footer-section company">
          <div className="footer-logo">
            <img src="/assets/logo.png" alt="GoKwiK Media" />
            <br></br>
          
          </div>
          <p>
            GoKwik Media delivers smart digital marketing solutions to grow
            brands with SEO, ads, and creative strategies.
          </p>
          <p className="footer-contact">
            <FaPhoneAlt className="footer-icon" /> +91 96248 83636
          </p>
          <p className="footer-contact">
            <FaMapMarkerAlt className="footer-add" />  417, 4th Floor, Escon Plaza, Amroli,
          Surat, Gujarat, India - 394107.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <div className="footer-underline"></div>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section services">
          <h3>Services</h3>
          <div className="footer-underline"></div>
          <ul>
            <li>
              <Link to="/blog">Google Ads</Link>
            </li>
            <li>
              <Link to="/blog">Social Media Ads (Facebook/Instagram)</Link>
            </li>
            <li>
              <Link to="/blog">Social Media Optimization (SMO)</Link>
            </li>
             <li>
              <Link to="/blog">Social Media Management (SMM)</Link>
            </li>
             <li>
              <Link to="/blog">Search Engine Optimization (SEO)</Link>
            </li>
            <li>
              <Link to="/blog">Website Design & Development</Link>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-section newsletter">
          <h3>Our Newsletter</h3>
          <div className="footer-underline"></div>
          <p>
            Sign up to Privitar’s weekly newsletter to get the latest updates.
          </p>
          <form className="newsletter-form">
            <input type="email" placeholder="Enter Your E-mail" />
            <button type="submit">Subscribe</button>
          </form>

          <div className="social-icons">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.youtube.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 GoKwiK Media. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
